import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export enum MessageTrigger {
  // OCPP 1.6
  BOOT_NOTIFICATION = 'BOOT_NOTIFICATION',
  DIAGNOSTICS_STATUS_NOTIFICATION = 'DIAGNOSTICS_STATUS_NOTIFICATION',
  FIRMWARE_STATUS_NOTIFICATION = 'FIRMWARE_STATUS_NOTIFICATION',
  HEARTBEAT = 'HEARTBEAT',
  METER_VALUES = 'METER_VALUES',
  // OCPP 2.0.1
  LOG_STATUS_NOTIFICATION = 'LOG_STATUS_NOTIFICATION',
  SIGN_CHARGING_STATION_CERTIFICATE = 'SIGN_CHARGING_STATION_CERTIFICATE',
  SIGN_V2G_CERTIFICATE = 'SIGN_V_2_G_CERTIFICATE',
  STATUS_NOTIFICATION = 'STATUS_NOTIFICATION',
  TRANSACTION_EVENT = 'TRANSACTION_EVENT',
  SIGN_COMBINED_CERTIFICATE = 'SIGN_COMBINED_CERTIFICATE',
  PUBLISH_FIRMWARE_STATUS_NOTIFICATION = 'PUBLISH_FIRMWARE_STATUS_NOTIFICATION',
  // OCPP 2.1
  SIGN_V2G20_CERTIFICATE = 'SIGN_V_2_G_20_CERTIFICATE',
  CUSTOM_TRIGGER = 'CUSTOM_TRIGGER'
}

export interface TriggerMessageCommand {
  connectorId?: number;
  evseId?: number;
  messageTrigger: MessageTrigger;
  customTrigger?: string;
}

const client = createClient('/rest/operator-api/charging-stations');

export const triggerMessage: SaveOperation<TriggerMessageCommand, void, string> = postRequestFactory<
  TriggerMessageCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/trigger-message',
  permissionId: commandPermissions.TRIGGER_MESSAGE
});
